import { tokenStorage } from '@/lib/token-storage'
import { LogOut, Eye } from 'lucide-react'

/**
 * Shown across the top while a platform user is impersonating a tenant.
 * Exit restores the stashed owner token and reloads back into the platform.
 */
export function ImpersonationBanner() {
  if (!tokenStorage.isImpersonating()) return null
  const tenant = tokenStorage.getImpersonationTenant()

  const exit = () => {
    const owner = tokenStorage.getImpersonationOwnerToken()
    tokenStorage.endImpersonation()
    if (owner) tokenStorage.set(owner)
    else tokenStorage.clear()
    // Hard reload re-bootstraps identity from the restored token. The platform
    // owner belongs in the admin console (separate origin), so exit there.
    const adminUrl = (import.meta.env.VITE_ADMIN_URL as string | undefined) ?? '/login'
    window.location.assign(adminUrl)
  }

  return (
    <div className="flex items-center justify-center gap-3 bg-brand-terracotta px-4 py-2 text-sm font-medium text-white">
      <Eye className="h-4 w-4" />
      <span>
        Viewing as <strong>{tenant}</strong> — you are impersonating this tenant.
      </span>
      <button
        onClick={exit}
        className="inline-flex items-center gap-1.5 rounded-md bg-white/15 px-2.5 py-1 text-xs font-semibold hover:bg-white/25"
      >
        <LogOut className="h-3.5 w-3.5" /> Exit
      </button>
    </div>
  )
}
